import {Injectable, Inject} from 'ng-metadata/core';
import {HttpService} from '../infra/httpRequest/http.service';
import {ConfigurationUtil} from '../nddUtils/configurationUtil.service';
import {LinkedUserSelectorService} from './linkedUserSelector/linkedUserSelector.service';
import appConfigModule from '../appConfig/appConfig.module';

@Injectable()
export class AccountService{

    private myAccountBaseUrl:any;
    private $http: ng.IHttpService;
    private resquestInProgress:Object = {};

    //Default Paths. will be updated in constructor;
        private baseUrl = this.configurationUtil.isSuprima() ? '/primaws/rest/priv' : '/primo_library/libweb/webservices/rest/v1';
        private ilsServices = {
        'counters': {
            'path': this.baseUrl + '/myaccount/counters',
            'method': 'GET'
        },
        'loans': {
            'path': this.baseUrl + '/myaccount/loans',
            'method': 'GET'
        },
        'renew_loan': {
            'path': this.baseUrl + '/myaccount/renew_loans',
            'method': 'POST'
        },
        'renew_all_loans': {
            'path': this.baseUrl + '/myaccount/renew_all_loans',
            'method': 'POST'
        },
        'requests': {
            'path': this.baseUrl + '/myaccount/requests',
            'method': 'GET'
        },
        'deposits': {
            'path': this.baseUrl + '/myaccount/depositsInfo',
            'method': 'GET'
        },
        'representationInfo': {
            'path': this.baseUrl + '/myaccount/representationInfo',        
            'method': 'GET'
        },        
        'fines': {
            'path': this.baseUrl + '/myaccount/fines',
            'method': 'GET'
        },
        'cancel_requests': {
            'path': this.baseUrl + '/myaccount/cancel_requests',
            'method': 'POST'
        },
        'blocks_messages': {
            'path': this.baseUrl + '/myaccount/blocks_messages',
            'method': 'GET'
        },
        'personal_settings': {
            'path': this.baseUrl + '/myaccount/personal_settings',
            'method': 'GET'
        },
        'update_personal_settings': {
            'path': this.baseUrl + '/myaccount/update_personal_settings',
            'method': 'POST'
        },
        'submit_deposit': {
            'path': this.baseUrl + '/myaccount/submit_deposit',
            'method': 'POST'
        },
        'withdraw_deposit': {
            'path': this.baseUrl + '/myaccount/withdraw_deposit',
            'method': 'POST'
        },
        'collection': {
            'path': this.baseUrl + '/myaccount/collection',
            'method': 'GET'
        }
    };
    constructor(@Inject('restBaseURLs') private restBaseURLs,
                private httpService: HttpService,
                private configurationUtil : ConfigurationUtil,
                private linkedUserSelectorService: LinkedUserSelectorService){
        this.myAccountBaseUrl = restBaseURLs.myAccountBaseURL;
        this.refreshRestPaths();
    }




    public getServices(){
        return this.ilsServices;
    }

    public makeIlsRequest(serviceName: string, parmas: Object){
        if(!parmas){
            parmas= {};
        }
        if(this.linkedUserSelectorService.selectedInstitution){
            if(!this.configurationUtil.isSuprima()) {
                parmas['linked_inst']= this.linkedUserSelectorService.selectedInstitution.institutionCode || ''; }
            else {
                parmas['inst_code']= this.linkedUserSelectorService.selectedInstitution.institutionCode || ''; }
            parmas['patron_id']= this.linkedUserSelectorService.selectedInstitution.patronId || '';
        }
        let serviceDetails = this.ilsServices[serviceName];
        this.resquestInProgress[serviceName] = true;

        return this.httpService.call(serviceDetails.method, serviceDetails.path, parmas)
            .then(
                (response)=> {
                    return this.ilsRequestSuccess(response);
                },
                (error)=>{
                    return this.ilsRequestFailure(error, serviceName, parmas);
                }
            ).finally( () =>
                this.resquestInProgress[serviceName] = false
            );
    }

    public getDisplayBackToSearchLink(){
        if(this.configurationUtil.getBackendSystem() === 'suprima'){
            if(this.configurationUtil.getSummonOverAlma() === true){
                return false;
            }
        }
        return true;
    }

    get requestInProgress(){
        return this.resquestInProgress || false;
    }

    private refreshRestPaths(){
        let ilsServices = this.ilsServices;
        this.httpService.call('GET',this.myAccountBaseUrl)
            .then(function(response){
                let services = response;
                Object.keys(services).map(function(key){
                    ilsServices[key] = services[key];
                });
            });
    }

    private ilsRequestSuccess(response){
        return response;
    }

    private ilsRequestFailure(reason, serviceName, params) {
        console.error(reason, serviceName);
        return reason;
    }

}

export class StatusMsg {
    public isSuccess:boolean;
    public msg: string;

    constructor(isSuccess:boolean, msg:string){
        this.isSuccess = isSuccess;
        this.msg = msg;
    }
}
export default [ appConfigModule.name ];


// WEBPACK FOOTER //
// ./src/main/webapp/components/account/account.service.ts